import React from 'react';
import { Plus } from 'lucide-react';
import Button from '../../common/Button';
import JobSeekerCard from './JobSeekerCard';
import type { JobSeekerProfile } from '../../../types/profiles';

interface JobSeekerGridProps {
  profiles: JobSeekerProfile[];
  currentUserId?: string;
  showCreateButton?: boolean;
  onCreateProfile: () => void;
  onEditProfile: (profile: JobSeekerProfile) => void;
  onDeleteProfile: (profileId: string) => void;
}

export default function JobSeekerGrid({ 
  profiles, 
  currentUserId,
  showCreateButton = false,
  onCreateProfile,
  onEditProfile,
  onDeleteProfile 
}: JobSeekerGridProps) {

  return (
    <div>
      {showCreateButton && (
        <div className="mb-6">
          <Button
            variant="primary"
            icon={Plus}
            onClick={onCreateProfile}
          >
            Create Profile
          </Button>
        </div>
      )}

      {profiles.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <p className="text-gray-500">
            No job seeker profiles available yet. {currentUserId ? 'Be the first to create one!' : 'Check back soon!'}
          </p>
        </div>
      ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {profiles.map((profile) => (
          <JobSeekerCard
            key={profile.id}
            profile={profile}
            userEmail={profile.userId === currentUserId ? 'Current User' : null}
            onEdit={() => onEditProfile(profile)}
            onDelete={() => onDeleteProfile(profile.id)}
            canEdit={profile.userId === currentUserId}
          />
        ))}
      </div>
      )}
    </div>
  );
}